import React, { useEffect, useState } from "react";
import { Cake, PartyPopper, Check } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const inputCls = "w-full rounded-2xl border-2 border-[#19324A]/10 bg-white px-4 py-3 text-sm outline-none focus:border-[#FF6B9D]";
const fmt = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long" });

export default function PupBirthdayForm({ defaultEmail = "", lockEmail = false, defaultName = "", compact = false }) {
  const [form, setForm] = useState({ email: defaultEmail, first_name: defaultName, pup_name: "", birthday: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const [pups, setPups] = useState([]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const loadPups = (email) => { if (email) api.get("/pup-birthdays", { params: { email } }).then(({ data }) => setPups(data.pups)).catch(() => {}); };
  useEffect(() => { loadPups(defaultEmail); }, [defaultEmail]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/pup-birthdays", form);
      setDone(data);
      loadPups(form.email);
      setForm((f) => ({ ...f, pup_name: "", birthday: "" }));
      toast.success(`${data.pup_name} is in the Birthday Club 🎂`);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="birthday-form-wrap">
      {done && (
        <div className="mb-4 rounded-2xl bg-[#7ED957]/15 border-2 border-[#7ED957] p-4 flex items-start gap-3" data-testid="birthday-success">
          <PartyPopper className="w-5 h-5 text-[#166534] shrink-0 mt-0.5" />
          <p className="text-sm text-[#19324A]"><strong>{done.pup_name}</strong> is on the list! Their next birthday is <strong>{fmt(done.next_birthday)}</strong>
            {done.days_away > 7 ? <> — your 15% treat code lands on {fmt(done.treat_from)}.</> : <> — your 15% treat code is on its way in tomorrow morning's post run.</>}</p>
        </div>
      )}
      <form onSubmit={submit} className={`grid gap-3 ${compact ? "" : "sm:grid-cols-2"}`} data-testid="birthday-form">
        {!lockEmail && (
          <>
            <input type="email" required value={form.email} onChange={set("email")} placeholder="Your email" autoComplete="email" className={inputCls} data-testid="birthday-email" />
            <input value={form.first_name} onChange={set("first_name")} placeholder="Your first name (optional)" className={inputCls} data-testid="birthday-first-name" />
          </>
        )}
        <input required maxLength={40} value={form.pup_name} onChange={set("pup_name")} placeholder="Your pup's name" className={inputCls} data-testid="birthday-pup-name" />
        <input type="date" required value={form.birthday} onChange={set("birthday")} max={new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10)} className={inputCls} data-testid="birthday-date" />
        <button type="submit" disabled={busy} className={`btn-pink disabled:opacity-60 ${compact ? "" : "sm:col-span-2"}`} data-testid="birthday-submit">
          <Cake className="w-5 h-5" /> {busy ? "Adding…" : "Add my pup"}
        </button>
      </form>
      {pups.length > 0 && (
        <ul className="mt-4 space-y-2" data-testid="birthday-pups">
          {pups.map((p) => (
            <li key={p.pup_name} className="flex items-center justify-between rounded-2xl bg-white border-2 border-[#19324A]/8 px-4 py-2.5 text-sm" data-testid={`birthday-pup-${p.pup_name.toLowerCase().replace(/\s+/g, "-")}`}>
              <span className="font-semibold text-[#19324A] inline-flex items-center gap-2"><Check className="w-4 h-4 text-[#7ED957]" /> {p.pup_name}</span>
              <span className="text-xs text-[#19324A]/60">{p.days_away === 0 ? "Birthday today! 🎉" : `Next birthday in ${p.days_away} day${p.days_away === 1 ? "" : "s"}`}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
